import { Box, LinearProgress, styled } from '@mui/material';
import React from 'react';

export const Loader: React.FC = () => {
  const DisabledBackground = styled(Box)({
    width: '100%',
    height: '100%',
    position: 'fixed',
    background: '#ccc',
    opacity: 0.5,
    zIndex: 1,
  });

  return (
    <>
      <LinearProgress sx={{ zIndex: 2 }} />
      <DisabledBackground />
    </>
  );
};
